import React, { useState } from 'react';
import { Mail, Instagram, ArrowRight } from 'lucide-react';
import { useSiteData } from '../contexts/SiteDataContext';

const Footer = () => {
  const { artistInfo } = useSiteData();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error] = useState('');

  if (!artistInfo) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = 'Newsletter signup';
    const body = `Please add me to your newsletter: ${email}`;
    window.location.href = `mailto:${artistInfo.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setSubmitted(true);
    setEmail('');
    setTimeout(() => setSubmitted(false), 5000);
  };

  return (
    <footer className="border-t border-[#eee] mt-32" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          <div>
            <p className="text-[14px] font-medium text-[#1a1a1a] mb-3">{artistInfo.name}</p>
            <p className="text-[13px] text-[#999] leading-relaxed">{artistInfo.location}</p>
          </div>

          <div>
            <p className="text-[13px] font-medium text-[#1a1a1a] mb-3">Stay connected</p>
            <p className="text-[13px] text-[#999] mb-4 leading-relaxed">
              Receive updates on new work, exhibitions, and available pieces.
            </p>
            {submitted ? (
              <p className="text-[13px] text-[#555]" data-testid="newsletter-success">Thank you for subscribing.</p>
            ) : (
              <form onSubmit={handleSubmit} className="flex gap-2" data-testid="newsletter-form">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="Email address"
                  data-testid="newsletter-email-input"
                  className="flex-1 bg-[#f7f7f7] border border-[#e8e8e8] text-[13px] text-[#1a1a1a] px-4 py-2.5 outline-none focus:border-[#ccc] transition-colors placeholder:text-[#bbb]"
                />
                <button
                  type="submit"
                  data-testid="newsletter-submit-button"
                  className="bg-[#1a1a1a] hover:bg-[#333] text-white text-[12px] px-4 py-2.5 transition-colors duration-300 flex items-center gap-2"
                >
                  <ArrowRight size={13} />
                </button>
              </form>
            )}
            {error && <p className="text-[12px] text-red-500 mt-2" data-testid="newsletter-error">{error}</p>}
          </div>

          <div className="flex flex-col items-start md:items-end gap-4">
            <div className="flex items-center gap-5">
              <a
                href={`mailto:${artistInfo.email}`}
                className="text-[#999] hover:text-[#1a1a1a] transition-colors duration-300"
                aria-label="Email"
                data-testid="footer-email-link"
              >
                <Mail size={17} />
              </a>
              <a
                href={artistInfo.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#999] hover:text-[#1a1a1a] transition-colors duration-300"
                aria-label="Instagram"
                data-testid="footer-instagram-link"
              >
                <Instagram size={17} />
              </a>
            </div>
            <a
              href={`mailto:${artistInfo.email}`}
              className="text-[13px] text-[#999] hover:text-[#1a1a1a] transition-colors"
            >
              {artistInfo.email}
            </a>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#f0f0f0]">
          <p className="text-[11px] text-[#ccc]">
            &copy; {new Date().getFullYear()} {artistInfo.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
